import Vue from "vue";
import { convertIdToPubNubKind } from "../../lib/utilities";

function initialState() {
  return {
    pubnub: {},
    chatWindow: [],
    recievedMessage: "",
    pubnubHistory: [],
    groupId: ""
  };
}

const state = initialState();

const getters = {
  pubnub(state) {
    return state.pubnub;
  },
  chatWindow(state) {
    return state.chatWindow;
  },
  recievedMessage(state) {
    return state.recievedMessage;
  },
  pubnubHistory(state) {
    return state.pubnubHistory;
  },
  groupId(state) {
    return state.groupId;
  },
  canChatWithUser: (state, getters, rootState, rootGetters) => (userId) => {
    // AutoAlert users viewing dealer users cannot initiate chat
    if (!userId || rootGetters.User.AccountID != rootGetters.User.ViewAccountID) return false;

    const userInfo = rootGetters.accountUsersDictionary[userId];

    if (!userInfo) return false;

    const allowedStoreIds = rootGetters.User.ViewAllowedStores.map(vas => vas.AccountPlatformID);

    // Allow chat if there is a common accessible store between the current user and the selected user
    return (userInfo.HasAllPlatformAccess || (userInfo.AccountPlatformIDs || [userInfo.AccountPlatformID]).some(platformId => allowedStoreIds.includes(platformId)));
  }
};

const actions = {
  sendMessage(context, data) {
    let ChatPackage = {
      Message: data.message,
      UserIds: [data.userId, data.recipientId]
    };
    return new Promise(async resolve => {
      resolve(
        await Vue.http
          .post("/message/send", ChatPackage)
          .then(resp => {
            if (!context.getters.groupId) {
              context.commit("groupId", resp.data.Data.GroupResponse.GroupId);
            }
            return true;
          })
          .catch(error => {
            console.log("Error: ", error);
            return false;
          })
      );
    });
  },
  handlePubNubMessage(context, message) {
    if (message && message.msg && message.msg.GroupId && message.msg.GroupId === context.getters.groupId && message.msg.Messages && message.msg.Messages[0].SenderId !== context.getters.User.Id) {
      context.commit("recievedMessage", message.msg.Messages[0]);
    }
  },
  getMessageHistoryForGroup(context, count) {
    let data = {
      GroupId: context.getters.groupId,
      MessageBadgeCount: context.getters.recievedMessage.MessageBadgeCount,
      FormCount: context.getters.recievedMessage.FormCount,
      LastViewedUtcTicks: context.getters.recievedMessage.LastViewedUtcTicks
    };
    var matchingRecord = generateMessageGroupRecord(data);

    // TODO: Replace with embedded Inbox
    // return new Promise(async resolve => {
    //   resolve(
    //     await context.getters.pubnub
    //       .history({
    //         channel: matchingRecord.PubnubId,
    //         count: count,
    //         includeTimetoken: true,
    //         start: matchingRecord.StartTimetoken
    //       })
    //       .then(response => {
    //         if (response.messages.length > 0 && context.getters.pubnubHistory.length !== response.messages.length) {
    //           context.commit("pubnubHistory", response.messages.map(x => x.entry.msg));
    //           return true;
    //         } else return false;
    //       })
    //   );
    // });
  },
  checkForGroup(context, data) {
    return new Promise(async resolve => {
      resolve(
        await Vue.http
          .get("group/CheckForGroup?staffids=" + data.userId + "&staffids=" + data.recipientId)
          .then(r => {
            if (r.data.Data) {
              context.commit("groupId", r.data.Data.GroupId);
              context.dispatch("getMessageHistoryForGroup", 20);
              return true;
            } else return false;
          })
          .catch(error => {
            return false;
          })
      );
    });
  },
  setChatWindow(context, data) {
    context.commit("chatWindow", data);
  }
};

const mutations = {
  setPubNub(state, data) {
    state.pubnub = data;
  },
  chatWindow(state, data) {
    state.chatWindow = data;
  },
  recievedMessage(state, msg) {
    state.recievedMessage = msg;
  },
  pubnubHistory(state, data) {
    state.pubnubHistory = data;
  },
  groupId(state, id) {
    state.groupId = id;
  }
};

function generateMessageGroupRecord(data) {
  // Sample record for a group
  let matchingRecord = {
    GroupId: data.GroupId, //GroupId
    PubnubId: convertIdToPubNubKind(data.GroupId), //PubnubId for group
    Messages: [], //Active messages that can be displayed to user
    AllMessages: [], //All messages in this group (to keep track of the deleted messages)
    UnreadMessageId: null, //MessageId for first unread message
    MessageBadgeCount: data.MessageBadgeCount, //Count of unread messages in this group
    StartTimetoken: 0, //Time to fetch PubNub messages from
    EndTimetoken: 0, //Time to fetch PubNub messages to
    Iteration: 0, //Represents the number of calls to Pubnub to fetch displayable messages
    HasMoreMessages: true, //To identify if the group has more messages to fetch
    FetchingMessages: false, //To identify if the PubNub client is currently fetching messages
    ErrorFetchingMessages: false, //To display a note indicating that there was an error fetching messages
    PinnedMessages: [], //Pinned messages in this conversation
    LoadingPinnedMessages: false, //To display loading indicator while fetching pinned messages
    LoadedPinnedMessages: false, //To prevent additional calls to api to fetch pinned messages
    Attachments: [], //Attachments in this conversation
    LoadingAttachments: false, //To display loading indicator while fetching attachments
    HasMoreAttachments: true, //To identify if the group has more attachments to fetch
    LoadAttachmentsFrom: 0, //The start index for attachments to fetch from API
    IsLoadingForms: false, //To handle loading of forms for a request
    Forms: [], //To display forms for a request
    FormCount: data.FormCount, //Count of forms in this group
    LastViewedUtcTicks: data.LastViewedUtcTicks //UtcTicks of last seen message
  };
  return matchingRecord;
}

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Chat.js